import { render, staticRenderFns } from "./InstaIcon.vue?vue&type=template&id=50b49664&scoped=true"
import script from "./InstaIcon.vue?vue&type=script&lang=js"
export * from "./InstaIcon.vue?vue&type=script&lang=js"
import style0 from "./InstaIcon.vue?vue&type=style&index=0&id=50b49664&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b49664",
  null
  
)

export default component.exports